import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierRemarksController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierRemarksController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/remarks'
*/
const UpdateItemDossierRemarksController = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateItemDossierRemarksController.url(args, options),
    method: 'patch',
})

UpdateItemDossierRemarksController.definition = {
    methods: ["patch"],
    url: '/api/dossier/{dossier}/item-dossier/{itemDossier}/remarks',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierRemarksController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierRemarksController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/remarks'
*/
UpdateItemDossierRemarksController.url = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            itemDossier: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        itemDossier: typeof args.itemDossier === 'object'
        ? args.itemDossier.id
        : args.itemDossier,
    }

    return UpdateItemDossierRemarksController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{itemDossier}', parsedArgs.itemDossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\UpdateItemDossierRemarksController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/UpdateItemDossierRemarksController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}/remarks'
*/
UpdateItemDossierRemarksController.patch = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateItemDossierRemarksController.url(args, options),
    method: 'patch',
})

export default UpdateItemDossierRemarksController